import React from 'react';
import { Checkbox } from 'antd';
import AnswerCard from '../AnswerCard';
import AnswerType from '../AnswerType';
import { injectIntl } from 'react-intl';

const CheckboxGroup = Checkbox.Group;

function AnswerCheckbox(props) {
	const { answers, onVariantChanged, value, onOptionsChanged, questionId, questions, messages, intl: { formatMessage }  } = props;
	if (!questionId || !questions) return null;
	const question = questions[questionId];
	const title = `survey.question.${questionId}`;
	return (
		<AnswerCard title={formatMessage(messages[title])} {...props}>
			<CheckboxGroup value={value} onChange={onVariantChanged}>{question.answers.map((id, i) => {
				let { title, ...v } = answers[id];
				title = `survey.answers.${id}`;
				return (<div key={id}>
					<Checkbox value={i}
					          style={{ display: 'inline-block' }}>{formatMessage(messages[title])}</Checkbox>
					<AnswerType
						value={value}
					    onChange={onOptionsChanged}
					    selected={(value && value.includes(i)) || false} {...v}/>
				</div>);
			})}
			</CheckboxGroup>
		</AnswerCard>
	);
}

export default injectIntl(AnswerCheckbox);


// WEBPACK FOOTER //
// ./src/components/AnswerCheckbox/AnswerCheckbox.js